// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_fragment_agentV2(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
              "AnonymousForSalePropertyAgent",
              "VisibleForSalePropertyAgent"
            ]);
}

var fragmentConverter = {"__root":{"agentV2_VisibleForSalePropertyAgent_agent":{"f":""},"agentV2_AnonymousForSalePropertyAgent":{"f":""},"agentV2":{"u":"fragment_agentV2"},"":{"f":""}}};

var fragmentConverterMap = {
  fragment_agentV2: unwrap_fragment_agentV2
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function forSalePropertyAgentVisibilityReason_decode($$enum) {
  if ($$enum === "OWN_ANONYMOUS" || $$enum === "VISIBLE_TO_ALL") {
    return $$enum;
  }
  
}

function forSalePropertyAgentVisibilityReason_fromString(str) {
  return forSalePropertyAgentVisibilityReason_decode(str);
}

var Utils = {
  forSalePropertyAgentVisibilityReason_decode: forSalePropertyAgentVisibilityReason_decode,
  forSalePropertyAgentVisibilityReason_fromString: forSalePropertyAgentVisibilityReason_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuietPropertyMatchPopup_Agent_forSalePropertyV5",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "agentV2",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "Agent",
                  "kind": "LinkedField",
                  "name": "agent",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "ClientPageMatchCardAgent_agent"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "BuyerPageMatchCardOwnAnonymousAgent_agent"
                    }
                  ],
                  "storageKey": null
                },
                "action": "THROW"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visibilityRule",
                "storageKey": null
              }
            ],
            "type": "VisibleForSalePropertyAgent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BuyerPageMatchAnonymousAgent_anonymousForSalePropertyAgent"
              }
            ],
            "type": "AnonymousForSalePropertyAgent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UseShouldShowPropertyDetails_propertyV5"
    }
  ],
  "type": "ForSalePropertyV5",
  "abstractKey": null
};

var wrap_fragment_agentV2 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_agentV2 = unwrap_fragment_agentV2;
exports.wrap_fragment_agentV2 = wrap_fragment_agentV2;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
